// extracted by mini-css-extract-plugin
module.exports =  {"layout":"_0d624b9a27--layout--dVaQU","spinner":"_0d624b9a27--spinner--e_O7D","container":"_0d624b9a27--container--M0xiL","error":"_0d624b9a27--error--AcAkz"};